import { stateTheme, Theme } from '@infinitro/config';
import { get } from 'svelte/store';
import { flushIcons } from './flush-icons';
import { fomoIcons } from './fomoio-icons';
import { lunaIcons } from './luna-icons';
import { turboslotsIcons } from './turboslots-icons';
const icons = {
    [Theme.Flush]: flushIcons,
    [Theme.Fomo]: fomoIcons,
    [Theme.Luna]: lunaIcons,
    [Theme.Rocketbet]: fomoIcons,
    [Theme.Turboslots]: turboslotsIcons
};
/** Resolves an icon from the current theme’s on-disk map, then shared fallbacks. */
export function getIcon(iconName) {
    const theme = get(stateTheme);
    const selectedIcons = icons[theme] ?? flushIcons;
    return selectedIcons[iconName] || fomoIcons[iconName] || flushIcons[iconName];
}
